import React, { useContext } from "react";
import { UserContext } from "../../context/provider/UserProvider";
import { AuthFetch } from "../../services/api";

const urlBaseRepuestos = process.env.REACT_APP_TMAN_API + '/Replacement'

export const useAlmacenes = () => {

    const { stateUser , signOut } = useContext(UserContext);
    const codEmpresa = stateUser.codEmpresa

    const listadoAlmacenes = async () => {
        const response = await AuthFetch({
            url: urlBaseRepuestos,

        })
    }

    
    return {
        listadoAlmacenes,
    };
};
